import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage } from 'react-intl'
import $ from 'jquery'
import QuoteStatusSelect from "../quote/statusesselection.component.jsx";

class StatusQuote extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            status: this.props.status || '',
            currentStatus: this.props.currentStatus || '',
            endPoint: this.props.endPoint || '',
        }

        this.onClose = this.props.onClose
        this.closeModals = this.closeModals.bind(this)
        this.handleStatusChange = this.handleStatusChange.bind(this)
        this.applyStatusChange = this.applyStatusChange.bind(this)
        this.getAllowedStatuses = this.getAllowedStatuses.bind(this)
    }

    applyStatusChange(event) {
        event.preventDefault()
        AppContext.getApiClient().patch(this.state.endPoint, {
            status: this.state.status,
        }).then(r => this.closeModals(event, r))
    }

    handleStatusChange(status) {
        this.setState({
            status,
        });
    }

    componentDidMount() {
        $('#changeStatusModal').modal('show')
    }

    componentWillReceiveProps(nextProps, nextContext) {
    }

    closeModals(event, response) {
        event.preventDefault()
        $('#changeStatusModal').modal('hide')
        this.onClose(response)
    }

    getAllowedStatuses() {
        switch (this.state.currentStatus) {
            case 'cancelled': return ['draft']
            case 'approved': return ['proposed', 'approved']
            case 'declined': return ['proposed', 'approved', 'declined']
            default: return []
        }
    }

    render() {

        return (
            <div>
                {/************** Update Quote Status Modal ***************/}
                <div className="modal fade"
                    id="changeStatusModal"
                    role="dialog"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setStatusModalLabel">
                                    <FormattedMessage
                                        id="quote.set_status_modal.title"
                                        defaultMessage="Status"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <QuoteStatusSelect
                                        value={this.state.status}
                                        onChange={(status) => { this.handleStatusChange(status) }}
                                        multi={false}
                                        getAllowedStatuses={this.getAllowedStatuses}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.set_status_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <button type="button" className="btn btn-primary" disabled={!this.state.endPoint} onClick={this.applyStatusChange}>
                                    <FormattedMessage
                                        id="quote.set_status_modal.apply_discount_btn"
                                        defaultMessage="Update status"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StatusQuote





// WEBPACK FOOTER //
// ./src/quote/statusquote.component.jsx